import { tbAudio } from "./tbAudio";
var tbSoundInstance = /** @class */ (function () {
    function tbSoundInstance(sound, source) {
        this.startDelay = 0;
        this.looping = false;
        this.playing = false;
        this.paused = false;
        this.enginePaused = 0;
        this.timer = 0;
        this.delayed = false;
        this.started = false;
        this.pausedPosition = 0;
        this.pauseDuration = 0;
        this.pauseTimer = 0;
        this.sound = sound;
        this.startOffset = this.sound.startOffset;
        this.source = source;
        this.duration = this.sound.duration;
        this.id = Math.round(Date.now() * Math.random()) + "";
        this.tags = ["master", this.id].concat(this.sound.tags);
        this.priority = (this.sound.priority() !== undefined) ? this.sound.priority() : 10;
        this._init();
    }
    tbSoundInstance.prototype._init = function () {
        // set initial gain
        var totGain = 1;
        for (var t = 0; t < this.tags.length; t += 1) {
            if (tbAudio.tagVolumeMap[this.tags[t]] !== undefined) {
                totGain *= tbAudio.tagVolumeMap[this.tags[t]];
            }
        }
        if (tbAudio.usingWebAudio) {
            // tbAudio._gainNodes[this.id].gain.value = totGain;
        }
        else if (tbAudio.usingHTMLAudio) {
            this.source.volume = totGain;
        }
    };
    return tbSoundInstance;
}());
export { tbSoundInstance };
